import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, defer, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FeatureFlagsStore } from './feature-flags.store';
import { getVisibleFormTemplateTypes } from './form-template-types.utils';

@Injectable({ providedIn: 'root' })
export class FormTemplateTypesService {
  private readonly featureFlags = inject(FeatureFlagsStore);
  private readonly flagSync$ = toObservable(this.featureFlags.launchDarklySyncStateSignal);

  getVisibleTypesWhenReady(): Observable<string> {
    return defer(() => {
      const ready$ = this.featureFlags.launchDarklySyncStateSignal().resolved
        ? of(null)
        : this.flagSync$.pipe(
            // The observable may still replay an older state while its signal effect is pending.
            filter(() => this.featureFlags.launchDarklySyncStateSignal().resolved),
            take(1),
          );

      return ready$.pipe(map(() => getVisibleFormTemplateTypes(this.featureFlags.flagsSignal())));
    });
  }
}
